import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";

@Component({
  selector: 'app-sincronizar-keeta-status',
  templateUrl: './sincronizar-keeta.component.html',
  styleUrls: ['./sincronizar-keeta.component.scss']
})
export class SincronizarKeetaComponent implements OnInit {
  @Input() pedido: any = {}
  @Input() modoGrupoLojas = false;

  constructor(private pedidosService: PedidosService, private grupolojasService: GrupolojasService) {

  }

  ngOnInit(): void {
  }

  async sincronizarStatusPedido($event: any) {

    this.pedido.sincronizando = true;

    const service: any = this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;

    service.sincronizePedidoKeeta( this.pedido).then((resposta: any) => {
      this.pedido.sincronizando = false;
      if(resposta && resposta.id)
        Object.assign( this.pedido, resposta);
    }).catch((err) => {
      this.pedido.sincronizando = false;
    });

    $event.stopPropagation();
    $event.preventDefault();

    return false;
  }

}
